export default __webpack_public_path__ + "static/media/load.5bf3385a.png";